// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".detail-search-dialog[data-v-b3380ce8]  .el-form-item.remarks {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
